<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-30"
    >
      <div class="d-flex-row space-between md-row-to-col select_honor_top">
        <div class="d-flex-row justify-start flex-6 gap-18">
          <img
            src="/images/icons/select_gold.webp"
            alt="select_gold"
            class="select_gold"
            width="77"
            height="77"
          />
          <div class="d-flex-column justify-start align-start gap-0">
            <h6 class="bold-xxxl font-family-2 t-white">
              {{ $t("new.select_gold") }}
            </h6>
            <p class="t-grey font-family-2 regular-m">
              {{ $t("new.select_gold_desc") }}
            </p>
          </div>
        </div>
        <div class="flex-4 flex-md-10 justify-end">
          <ValueSetter
            v-model="numberOfGold"
            :min="minPurchase"
            :max="inStock"
            :step="1000"
          />
        </div>
      </div>
      <RangePircker
        :min="minPurchase"
        :max="inStock"
        v-model="numberOfGold"
        :step="1000"
        :steps="steps"
        :start-point="startLabel"
        :end-point="endLabel"
      />
    </div>
    <p
      class="font-family-2 t-danger regular-m"
      v-if="numberOfGold > checkoutStore.getDetails?.inStock"
    >
      *{{ $t("new.number_of_gold_error") }}
      {{ checkoutStore.getDetails?.inStock }}
    </p>
  </div>
</template>

<script>
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import RangePircker from "./RangePicker.vue";
export default {
  data() {
    return {
      numberOfGold: 18000000,
      steps: [],
    };
  },
  components: {
    ValueSetter,
    RangePircker,
  },
  computed: {
    startLabel() {
      const minPurchase = this.minPurchase; // Assuming you have minPurchase as a prop or data property
      if (minPurchase >= 1_000_000) {
        return (minPurchase / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
      } else if (minPurchase >= 1_000) {
        return (minPurchase / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
      }
      return minPurchase.toString();
    },
    endLabel() {
      const minPurchase = this.inStock; // Assuming you have minPurchase as a prop or data property
      if (minPurchase >= 1_000_000) {
        return (minPurchase / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
      } else if (minPurchase >= 1_000) {
        return (minPurchase / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
      }
      return minPurchase.toString();
    },
  },

  mounted() {
    this.numberOfGold = this.minPurchase;
  },
  watch: {
    numberOfGold() {
      this.checkoutStore.setDetails({
        ...this.checkoutStore.getDetails,
        numberOfGold: this.numberOfGold,
      });
    },
  },
  props: {
    minPurchase: {
      default: 300000,
    },
    inStock: {
      default: 18000000,
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    return { checkoutStore };
  },
};
</script>
